module.exports = __webpack_public_path__ + "img/n21.816887b5.jpeg";